export default __webpack_public_path__ + "3bd1d5e9e41ad1d34ed4140b5b838f79.svg";